<template>
  <router-link 
    :to="'/provider/' + provider.id"
    class="provider-card"
    style="color:#000">
    <div class="card no-border padding shadow-thin rounded grow-a-little">
      <div class="card-section no-padding">
        <div class="grid-x grid-padding-x align-middle">
          <div 
            class="cell small-5">
            <img 
              v-if="provider.image_url" 
              :src="provider.image_url"
              class="square rounded" />
          </div>
          <div 
            class="cell small-7">
            <div class="profile">
              <div style="padding: .5rem">
                <h6 class="bold">{{ provider.formatted_name }}</h6>
                <p v-if="provider.specialties" class="no-margin">
                  {{ provider.specialties[0].title }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ProviderCard',
  props: {
    provider: {
      type: Object,
      required: true
    }
  }
}
</script>
